import { createActions, handleActions } from 'redux-actions';

const initState = {
  leftConvSetting: {
    listMode: 'normal', // 'noraml' & 'simple' & 'custom'
    sortMode: 'new_msg_first', // new_msg_first & conv_created_on
    sinkDown: true,
    customListModeSetting: {
      showType: ['mine', 'sendMsg', 'coll', 'mention'],
      mineSetting: { mineShowType: 'default' },
      collSetting: { collShowType: 'default' }
    }
  },
  rightRelateSetting: {
    showType: ['quick'],
    qucikShowType: 'tab' // tab fixed
  },
  volumeSetting: {
    showType: ['newMsg', 'newConv', 'redirectFrom'],
    volume: 100
  },
  notificationSetting: {
    showType: ['newMsg', 'newConv', 'redirectFrom', 'redirectTo']
  },
  // 折叠设置
  foldSetting: []
};

export const { mergeConvSetting } = createActions({
  mergeConvSetting: result => result
});

const quickReply = handleActions(
  {
    [mergeConvSetting]: (state, action) => {
      if (action.payload) {
        return Object.assign({}, state, action.payload);
      }
      return state;
    }
  },
  initState
);

export default quickReply;
